import React from "react"

export const footer = []

export const FooterContext = React.createContext(footer)
